import React from 'react';
import { EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

/** Discreet banner for users put in STANDBY by an admin (hidden from feeds, can still edit). */
const StandbyBanner = () => {
  const { user } = useAuth();
  const { t } = useTranslation('common');
  if (!user || !user.standby || user.is_admin) return null;
  return (
    <div
      className="md:pl-[72px] xl:pl-[245px]"
      data-testid="standby-banner"
    >
      <div className="mx-4 mt-2 flex items-start gap-2 rounded-lg border border-orange-500/30 bg-orange-500/10 px-3 py-2 text-xs text-orange-200">
        <EyeOff className="mt-0.5 h-4 w-4 shrink-0" />
        <p>{t('standby_banner')}</p>
      </div>
    </div>
  );
};

export default StandbyBanner;
